export const ErrorMessage = () => (
  <div className="flex min-h-screen w-full flex-col items-center justify-center p-8">
    <div className="flex max-w-[400px] flex-col items-center gap-4 rounded-lg bg-white px-10 py-10 shadow-md">
      <img
        className="mb-6 aspect-auto w-[150px] cursor-pointer"
        src="/images/pig-error-v2.png"
      />
      <h1 className="text-center text-2xl font-bold text-black dark:text-black">
        Ajajaj! Prasátkům se nedaří otevřít dotazník.
      </h1>
      <p className="text-center text-black dark:text-black">
        Zkuste otevřít odkaz dotazníku přímo v Safari prohlížeči.
      </p>
      <p className="text-center text-black dark:text-black">
        Nebo otevřete dotazník mimo anonymní okno.
      </p>
    </div>
  </div>
);
